import React from 'react';
import { observer } from 'mobx-react';

import './technician-style.scss';


const Technician = ({ kiosksCaption }) => (
  <div className='technician'>
    <div className='technician-location'>
      {
        kiosksCaption
      }
    </div>
  </div>
);

export default observer(Technician);
